export enum DatesToMoveIn {
  AsSoonAsPossible = 'AS_SOON_AS_POSSIBLE',
  FourMonthsPlus = 'FOUR_MONTHS_PLUS',
  NotSureYet = 'NOT_SURE_YET',
  OneToTwoMonths = 'ONE_TO_TWO_MONTHS',
  ThreeToFourMonths = 'THREE_TO_FOUR_MONTHS',
}
